import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "row g-3 align-items-end mb-4" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "form-label fs-14 text-title" }
const _hoisted_6 = { class: "d-flex gap-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "form-label fs-14 text-title" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "form-label fs-14 text-title" }
const _hoisted_13 = { class: "sale-search-box position-relative" }
const _hoisted_14 = ["value", "placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "sale-results-list shadow-sm"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "d-block text-title" }
const _hoisted_18 = { class: "text-muted d-block small" }
const _hoisted_19 = { class: "sale-meta" }
const _hoisted_20 = {
  key: 0,
  class: "p-3 text-muted text-center small"
}
const _hoisted_21 = { class: "row g-3 mb-4" }
const _hoisted_22 = { class: "col-lg-6" }
const _hoisted_23 = { class: "form-label fs-14 text-title" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-lg-6" }
const _hoisted_26 = { class: "form-label fs-14 text-title" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "col-lg-6" }
const _hoisted_29 = { class: "form-label fs-14 text-title" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "col-lg-6" }
const _hoisted_32 = { class: "form-label fs-14 text-title" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { value: "completed" }
const _hoisted_35 = { value: "pending" }
const _hoisted_36 = { class: "card border-0 bg-light-subtle rounded-3 mb-4" }
const _hoisted_37 = { class: "card-body p-3 p-xl-4" }
const _hoisted_38 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3" }
const _hoisted_39 = { class: "mb-1" }
const _hoisted_40 = { class: "text-muted mb-0 small" }
const _hoisted_41 = { class: "badge bg-white text-dark border px-3 py-2" }
const _hoisted_42 = { class: "table-responsive" }
const _hoisted_43 = { class: "table align-middle mb-0" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { class: "text-end" }
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = { class: "text-end" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  colspan: "7",
  class: "text-center text-muted py-4"
}
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "badge bg-light text-dark border" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = { class: "qty-stepper mx-auto" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["max", "value", "onChange"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "text-end" }
const _hoisted_59 = { class: "text-end" }
const _hoisted_60 = { class: "text-end" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "row g-3" }
const _hoisted_63 = { class: "col-lg-4" }
const _hoisted_64 = { class: "form-label fs-14 text-title" }
const _hoisted_65 = { class: "input-group" }
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "col-lg-4" }
const _hoisted_68 = { class: "form-label fs-14 text-title" }
const _hoisted_69 = { class: "input-group" }
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "col-lg-4" }
const _hoisted_72 = { class: "form-label fs-14 text-title" }
const _hoisted_73 = { class: "input-group" }
const _hoisted_74 = ["value"]
const _hoisted_75 = { class: "col-lg-8" }
const _hoisted_76 = { class: "form-label fs-14 text-title" }
const _hoisted_77 = ["value", "placeholder"]
const _hoisted_78 = { class: "col-lg-4" }
const _hoisted_79 = { class: "summary-card h-100" }
const _hoisted_80 = { class: "summary-row" }
const _hoisted_81 = { class: "summary-row" }
const _hoisted_82 = { class: "summary-row" }
const _hoisted_83 = { class: "summary-row" }
const _hoisted_84 = { class: "summary-row grand" }
const _hoisted_85 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_86 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("sales_return_page.return_reference")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control h-55 bg-white shadow-none border",
              value: _ctx.form.return_ref,
              readonly: ""
            }, null, 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("sales_return_page.date")), 1),
          _createElementVNode("input", {
            type: "datetime-local",
            class: "form-control h-55 bg-white shadow-none border",
            value: _ctx.form.date,
            readonly: ""
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("sales_return_page.original_sale")), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control h-55 bg-white shadow-none border pe-5",
              value: _ctx.saleSearch,
              placeholder: _ctx.$t('sales_return_page.original_sale_placeholder'),
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:saleSearch', ($event.target as HTMLInputElement).value))),
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focus-sale-search')))
            }, null, 40, _hoisted_14),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "search-icon" }, [
              _createElementVNode("i", { class: "ri-search-line" })
            ], -1)),
            (_ctx.showSaleResults)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleSearchResults, (sale) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: sale.id,
                      type: "button",
                      class: "sale-result-item",
                      onClick: ($event: any) => (_ctx.$emit('select-sale', sale))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", _hoisted_17, _toDisplayString(sale.reference_no), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(sale.customer_name || sale.customer?.name || _ctx.$t("sales_return_page.walk_in_customer")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(sale.warehouse_name || sale.warehouse?.name || _ctx.$t("sales_return_page.not_available_short")), 1)
                    ], 8, _hoisted_16))
                  }), 128)),
                  (!_ctx.saleSearchResults.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t("sales_return_page.no_matching_sales_found")), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("sales_return_page.sale_reference")), 1),
          _createElementVNode("input", {
            type: "text",
            class: "form-control h-55 bg-light shadow-none border",
            value: _ctx.form.reference_no,
            readonly: ""
          }, null, 8, _hoisted_24)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("sales_return_page.customer")), 1),
          _createElementVNode("input", {
            type: "text",
            class: "form-control h-55 bg-light shadow-none border",
            value: _ctx.form.customer_name,
            readonly: ""
          }, null, 8, _hoisted_27)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("sales_return_page.warehouse")), 1),
          _createElementVNode("input", {
            type: "text",
            class: "form-control h-55 bg-light shadow-none border",
            value: _ctx.form.warehouse_name,
            readonly: ""
          }, null, 8, _hoisted_30)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("sales_return_page.status")), 1),
          _createElementVNode("select", {
            class: "form-select h-55 bg-white shadow-none border",
            value: _ctx.form.status,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:status', ($event.target as HTMLSelectElement).value)))
          }, [
            _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.$t("sales_return_page.status_completed")), 1),
            _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.$t("sales_return_page.status_pending")), 1)
          ], 40, _hoisted_33)
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", null, [
              _createElementVNode("h6", _hoisted_39, _toDisplayString(_ctx.$t("sales_return_page.returned_items")), 1),
              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("sales_return_page.select_return_quantities")), 1)
            ]),
            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("sales_return_page.items_count", { count: _ctx.totalItems })), 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("table", _hoisted_43, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("sales_return_page.product")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("sales_return_page.code")), 1),
                  _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.$t("sales_return_page.sold_qty")), 1),
                  _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.$t("sales_return_page.return_qty")), 1),
                  _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.$t("sales_return_page.unit_price")), 1),
                  _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.$t("sales_return_page.subtotal")), 1),
                  _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.$t("sales_return_page.delete")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (!_ctx.items.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                      _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.$t("sales_return_page.select_original_sale_hint")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.product_id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.product_name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.product_code), 1),
                    _createElementVNode("td", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(item.max_quantity), 1)
                    ]),
                    _createElementVNode("td", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "qty-btn",
                          onClick: ($event: any) => (_ctx.$emit('update-qty', item.product_id, item.quantity - 1))
                        }, " - ", 8, _hoisted_55),
                        _createElementVNode("input", {
                          type: "number",
                          min: "1",
                          max: item.max_quantity,
                          class: "qty-input",
                          value: item.quantity,
                          onChange: ($event: any) => (_ctx.$emit('update-qty', item.product_id, Number(($event.target as HTMLInputElement).value)))
                        }, null, 40, _hoisted_56),
                        _createElementVNode("button", {
                          type: "button",
                          class: "qty-btn",
                          onClick: ($event: any) => (_ctx.$emit('update-qty', item.product_id, item.quantity + 1))
                        }, " + ", 8, _hoisted_57)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_58, "$" + _toDisplayString(Number(item.unit_price || 0).toFixed(2)), 1),
                    _createElementVNode("td", _hoisted_59, "$" + _toDisplayString(Number(item.subtotal || 0).toFixed(2)), 1),
                    _createElementVNode("td", _hoisted_60, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn p-0 border-0 text-danger",
                        onClick: ($event: any) => (_ctx.$emit('remove-item', item.product_id))
                      }, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "ri-delete-bin-line fs-18" }, null, -1)
                      ]))], 8, _hoisted_61)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("sales_return_page.discount")), 1),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("input", {
              type: "number",
              min: "0",
              class: "form-control h-55 bg-white shadow-none border",
              value: _ctx.form.discount,
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:discount', Number(($event.target as HTMLInputElement).value))))
            }, null, 40, _hoisted_66),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text bg-light border" }, "$", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("sales_return_page.tax")), 1),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("input", {
              type: "number",
              min: "0",
              class: "form-control h-55 bg-white shadow-none border",
              value: _ctx.form.tax,
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:tax', Number(($event.target as HTMLInputElement).value))))
            }, null, 40, _hoisted_70),
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text bg-light border" }, "$", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t("sales_return_page.shipping")), 1),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("input", {
              type: "number",
              min: "0",
              class: "form-control h-55 bg-white shadow-none border",
              value: _ctx.form.shipping,
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:shipping', Number(($event.target as HTMLInputElement).value))))
            }, null, 40, _hoisted_74),
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "input-group-text bg-light border" }, "$", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t("sales_return_page.notes")), 1),
          _createElementVNode("textarea", {
            class: "form-control bg-white shadow-none border resize-none",
            rows: "5",
            value: _ctx.form.note,
            placeholder: _ctx.$t('sales_return_page.notes_placeholder'),
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:note', ($event.target as HTMLTextAreaElement).value)))
          }, null, 40, _hoisted_77)
        ]),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.subtotal")), 1),
              _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.subTotal || 0).toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.discount")), 1),
              _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.form.discount || 0).toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.tax")), 1),
              _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.form.tax || 0).toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.shipping")), 1),
              _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.form.shipping || 0).toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_return_page.grand_total")), 1),
              _createElementVNode("strong", null, "$" + _toDisplayString(Number(_ctx.grandTotal || 0).toFixed(2)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_85, [
        _createElementVNode("button", {
          type: "button",
          class: "btn style-one d-inline-flex align-items-center px-4",
          disabled: _ctx.isSubmitting,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('submit')))
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ri-save-line me-2" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.submitLabel)), 1)
        ], 8, _hoisted_86)
      ])
    ])
  ]))
}